<div class="modal-header bg-primary text-white rounded-top">
  <h6 class="modal-title mb-0">Message Detail</h6>
  <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body" style="max-height: 500px; overflow-y: auto;">

  <table class="table table-borderless mb-3">
    <tr>
      <td style="width: 75%">
        <div><strong>Type:</strong> {{ item.methodsStr }}</div>
        <div><strong>From:</strong> {{ item.fromStr }}</div>
        @if (!isSent) {
          <div><strong>To:</strong>{{item.toOrgName}}</div>
        } @else {
          @if (item.recipientCount < 2) {
            <div><strong>To:</strong> {{ item.recipients }}</div>
          } @else {
            <div><strong>To:</strong> {{ item.recipientCount }} recipients</div>
            <div class="border p-1" style="max-height: 50px; overflow-y: auto;">
              {{ item.recipients }}
            </div>
          }
        }
        <!-- Recipients -->

        <div><strong>Subject:</strong> {{ item.subjectStr }}</div>
        <div><strong>Time:</strong> {{ item.localTime || item.time }}</div>
      </td>

      <!-- Reply buttons (only if not sent message) -->
      @if (!isSent) {
        <td class="text-end align-top">
          <button class="btn btn-sm btn-primary me-2 mb-1" (click)="replyMail()">Reply</button>
          <button class="btn btn-sm btn-primary" (click)="replyMail('all')">Reply All</button>
        </td>
      }
    </tr>
  </table>

  <!-- Body HTML or Text -->
  @if (item.bodyHtml) {
    <div [innerHTML]="bodyHtml" class="border p-2 mb-3" style="max-height: 250px; overflow-y: auto;"></div>
  }

  <!-- Image Attachment -->
  @if (attachmentUrl) {
    <div class="text-center mb-3">
      <img [src]="attachmentUrl" [alt]="attachmentName" class="img-fluid rounded shadow" />
    </div>
  }

  <!-- Video Attachment -->
  @if (messageVideoUrl) {
    <div class="mb-3">
      <video class="w-100 rounded shadow" controls>
        <source [src]="messageVideoUrl" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  }
</div>